<template>
  <div class="guarantor-new">
    <Row :gutter="16">
      <i-col span="16" offset="4">
        <Form ref="newForm" :model="guaModel" @on-validate="onValidate"
          :rules="modelValidate"
          label-position="left"
          :label-width="180">
          <FormItem label="受益人" prop="beneficiary">
            <Input v-model="guaModel.beneficiary" placeholder="输入受益人名称" />
            <span class="font-grey small">受益人是指担保合同中由被保险人或者投保人指定的享有保险金请求权的人，例如XX市人力资源与社会保障局。</span>
          </FormItem>
          <FormItem label="受益人社会信用代码" prop="beneficiaryBusinessLicense">
            <Input v-model="guaModel.beneficiaryBusinessLicense" placeholder="输入受益人社会信用代码" />
          </FormItem>
          <FormItem label="受益人地址" prop="beneficiaryAddress">
            <Input v-model="guaModel.beneficiaryAddress" placeholder="输入受益人地址" />
          </FormItem>
          <FormItem label="被保证人" prop="guaranteed">
            <Input v-model="guaModel.guaranteed" placeholder="输入被保证人名称" />
            <span class="font-grey small">被担保人是申请开保函的人,一般就是乙方，例如XXX建筑公司</span>
          </FormItem>
          <FormItem label="被保证人社会信用代码" prop="guaranteedBusinessLicense">
            <Input v-model="guaModel.guaranteedBusinessLicense" placeholder="输入被保证人社会信用代码" />
          </FormItem>
          <FormItem label="被保证人地址" prop="guaranteedAddress">
            <Input v-model="guaModel.guaranteedAddress" placeholder="输入被保证人地址" />
          </FormItem>
          <FormItem label="担保种类" prop="variety">
            <Select v-model="guaModel.variety" filterable>
              <Option v-for="(tp,idx) in guaTypes" :key="idx" :value="parseInt(tp.id)">{{tp.fullName}}</Option>
            </Select>
          </FormItem>
          <FormItem label="担保金额(元)" prop="amount">
            <InputNumber :min="0" :step="10000"
              style="width: 150px;display:inline-block"
              v-model="guaModel.amount"
              placeholder="输入担保金额(元)"></InputNumber>
            <Divider type="vertical" v-if="guaModel.amount" />
            <h3 style="display:inline-block" v-if="guaModel.amount"> {{`¥ ${guaModel.amount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</h3>
            <Divider type="vertical" v-if="guaModel.amount" />
            <h3 style="display:inline-block">{{$common.transformNumberIntoCHS(guaModel.amount)}}</h3>
            <div class="font-red" v-if="guaModel.gMethod===2">注意：联合保证时此处填写<b>主承保方承担的份额</b></div>
            <div class="font-grey" v-if="guaModel.gMethod===2">例：总保额为400万元，由两家承保人联保，每家承担200万元担保保额，此处仅填写本方承担的200万元即可。</div>
          </FormItem>
          <FormItem label="保额造价比(%)" prop="amountCostRatio">
            <h3>{{Math.round(guaModel.amountCostRatio*10000)/100}}%</h3>
          </FormItem>
          <FormItem label="担保方式" prop="gMethod">
            <RadioGroup v-model="guaModel.gMethod" type="button">
              <Radio :label="0">独立保证</Radio>
              <Radio :label="1" disabled>分段滚动</Radio>
              <Radio :label="2">联合保证</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="联合保证" prop="jointGuarantors" v-if="guaModel.gMethod===2">
            <div class="joint-guarantor" v-for="(joint,idx) in guaModel.jointGuarantors" :key="idx">
              <div class="remove-jointguarantor">
                <Button type="error" ghost shape="circle" icon="md-trash" @click="removeJointGuarantor(joint)"></Button>
              </div>
              <h3>联保人{{idx+1}}</h3>
              <Form :ref="`jointForm`" :model="joint"
                label-position="left"
                inline
                :label-width="140">
                <FormItem label="联保人" prop="guarantorId"
                  style="width:240px"
                  :rules="[
                    { required: true, message: '请填写联保人', trigger: 'blur' }
                  ]">
                  <Select v-model="joint.guarantorId" filterable placeholder="输入关键字选择联保人">
                    <Option v-for="(ag,jIdx) in getAvaliableGuarantors(idx)" :key="jIdx" :value="parseInt(ag.guarantorId)">{{ag.guarantorName}}</Option>
                  </Select>
                </FormItem>
                <FormItem label="分担担保金额(元)"
                  style="width:200px"
                  prop="amount"
                  :rules="[
                    { required: true, type: 'number', message: '请填写分担担保金额', trigger: 'blur' },
                    { validator: asyncJointGuarantorAllowanceValidator, options: {model: joint}, trigger: 'change' }
                  ]">
                  <InputNumber :min="0" :step="10000"
                    style="width: 150px;display:inline-block"
                    v-model="joint.amount"
                    @on-change="changeJointAmount"
                    placeholder="输入分担担保金额(元)"></InputNumber>
                  <Divider type="vertical" v-if="joint.amount" />
                  <h3 style="display:inline-block" v-if="joint.amount"> {{`¥ ${joint.amount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</h3>
                  <Divider type="vertical" v-if="joint.amount" />
                  <h3 style="display:inline-block">{{$common.transformNumberIntoCHS(joint.amount)}}</h3>
                </FormItem>
              </Form>
            </div>
            <Button type="text" icon="md-add" @click="addJointGuarantor">增加联保人</Button>
          </FormItem>
          <FormItem label="起止时间" prop="gStartDate">
            <DatePicker v-model="guaModel.gStartDate"
              type="datetime"
              placement="bottom-end"
              format="yyyy-MM-dd"
              @on-change="changeStartDate"
              placeholder="选择保函生效时间"
              style="width: 200px"></DatePicker>
            <span> - </span>
            <DatePicker v-model="guaModel.gEndDate"
              type="datetime"
              placement="bottom-end"
              format="yyyy-MM-dd"
              @on-change="changeEndDate"
              placeholder="选择保函截止时间"
              style="width: 200px"></DatePicker>
            <h3 style="display:inline-block" v-if="guaModel.gStartDate&&guaModel.gEndDate">
              &nbsp;{{require('moment')(guaModel.gEndDate).diff(require('moment')(guaModel.gStartDate), 'days')}}
              天
            </h3>
          </FormItem>
          <FormItem label="担保费率(%·月)" prop="gFeeRate">
            <InputNumber :min="0" :step="0.1" style="width: 200px"
              :formatter="value => `${value}%`"
              v-model="guaModel.gFeeRate" placeholder="担保费率(%·月)"></InputNumber>
            <div class="small font-grey"> 履约、农民工等类目请填写月费率，投标业务请填写实际费率</div>
          </FormItem>
          <FormItem label="担保费总额(元)" prop="fee">
            <InputNumber :min="0" :step="1000"
              style="width: 150px;display:inline-block"
              v-model="guaModel.fee"
              placeholder="输入担保费总额(元)"></InputNumber>
            <Divider type="vertical" v-if="guaModel.fee" />
            <h3 style="display:inline-block" v-if="guaModel.fee"> {{`¥ ${guaModel.fee}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</h3>
            <Divider type="vertical" v-if="guaModel.fee" />
            <h3 style="display:inline-block">{{$common.transformNumberIntoCHS(guaModel.fee)}}</h3>
          </FormItem>
          <FormItem label="现金反担保(元)" prop="counterCash">
            <InputNumber :min="0" style="width: 200px"
              v-model="guaModel.counterCash" :step="10000" placeholder="现金反担保(元)"></InputNumber>
            <Divider type="vertical" v-if="guaModel.counterCash" />
            <h3 style="display:inline-block" v-if="guaModel.counterCash"> {{`¥ ${guaModel.counterCash}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</h3>
            <Divider type="vertical" v-if="guaModel.counterCash" />
            <h3 style="display:inline-block">{{$common.transformNumberIntoCHS(guaModel.counterCash)}}</h3>
          </FormItem>
          <FormItem label="抵押质押(元)" prop="counterMortgage">
            <InputNumber :min="0" style="width: 200px"
              v-model="guaModel.counterMortgage" :step="10000" placeholder="抵押质押反担保(元)"></InputNumber>
            <Divider type="vertical" v-if="guaModel.counterMortgage" />
            <h3 style="display:inline-block" v-if="guaModel.counterCash"> {{`¥ ${guaModel.counterMortgage}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</h3>
            <Divider type="vertical" v-if="guaModel.counterMortgage" />
            <h3 style="display:inline-block">{{$common.transformNumberIntoCHS(guaModel.counterMortgage)}}</h3>
          </FormItem>
          <FormItem label="第三方反担保(元)" prop="counter3rdparty">
            <InputNumber :min="0" style="width: 200px"
              v-model="guaModel.counter3rdparty" :step="10000" placeholder="第三方反担保(元)"></InputNumber>
            <Divider type="vertical" v-if="guaModel.counter3rdparty" />
            <h3 style="display:inline-block" v-if="guaModel.counter3rdparty"> {{`¥ ${guaModel.counter3rdparty}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</h3>
            <Divider type="vertical" v-if="guaModel.counter3rdparty" />
            <h3 style="display:inline-block">{{$common.transformNumberIntoCHS(guaModel.counter3rdparty)}}</h3>
          </FormItem>
          <FormItem label="其他反担保(元)" prop="counterOther">
            <InputNumber :min="0" style="width: 200px"
              v-model="guaModel.counterOther" :step="10000" placeholder="其他反担保(元)"></InputNumber>
            <Divider type="vertical" v-if="guaModel.counterOther" />
            <h3 style="display:inline-block" v-if="guaModel.counterOther"> {{`¥ ${guaModel.counterOther}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</h3>
            <Divider type="vertical" v-if="guaModel.counterOther" />
            <h3 style="display:inline-block">{{$common.transformNumberIntoCHS(guaModel.counterOther)}}</h3>
          </FormItem>
          <FormItem label="反担保总额(元)" prop="counterTotal">
            <h3>{{guaModel.counterTotal}}元</h3>
            <Divider type="vertical" v-if="guaModel.counterTotal" />
            <h3 style="display:inline-block" v-if="guaModel.counterTotal"> {{`¥ ${guaModel.counterTotal}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</h3>
            <Divider type="vertical" v-if="guaModel.counterTotal" />
            <h3 style="display:inline-block">{{$common.transformNumberIntoCHS(guaModel.counterTotal)}}</h3>
          </FormItem>
          <FormItem label="反担保比例(%)" prop="counterRatio">
            <h3>{{Math.round(guaModel.counterRatio*10000)/100}}%</h3>
          </FormItem>
          <FormItem label="上报人" prop="opName">
            <Input v-model="guaModel.opName" placeholder="输入上报人" />
          </FormItem>
          <FormItem label="联系电话" prop="opContactTel">
            <Input v-model="guaModel.opContactTel" placeholder="输入联系电话" />
          </FormItem>
          <FormItem label="担保合同" prop="contractOssKeys" v-if="getSysConfig('enableEGua')"
            :rules="[{required:true,validator:arrayValidator,trigger:'blur'}]">
            <Upload
              ref="contractUploader"
              :data="OSSParam"
              :before-upload="handleBeforeUpload"
              :multiple="false"
              :on-success="handleUploadSuccess"
              :format="['jpg','jpeg','pdf','png']"
              :on-format-error="handleFormatError"
              :default-file-list="uploadedContractArray"
              :show-upload-list="false"
              :action="uploadParams.host">
              <Poptip trigger="hover" placement="right">
                <Button @click="getOSSParams(0)"><Icon type="ios-cloud-upload-outline"></Icon>上传附件</Button>
                <div slot="content">
                  <p>上传担保合同</p>
                  <p>格式限制：jpg,jpeg,pdf,png</p>
                  <p>大小限制：无 </p>
                </div>
              </Poptip>
            </Upload>
            <div class="contract">
              <div class="contract-thumb" v-for="(item,upIdx) in uploadedContractArray" :key="upIdx">
                <img :src="item.url" v-if="item&&item.url&&item.type==='image'">
                <span style="font-weight:bold;color:#999" v-if="item&&item.url&&item.type==='file'">{{item.surfix.toUpperCase()}}</span>
                <div class="contract-thumb-cover">
                  <Icon type="ios-eye-outline" v-if="item&&item.url&&item.type==='image'" @click="handleImgPreview(uploadedContractArray, upIdx)"></Icon>
                  <Icon type="ios-eye-outline" v-if="item&&item.url&&item.type==='file'" @click="previewImgUrl=item;showPreview=true"></Icon>
                  <Icon type="ios-trash-outline" @click="removeItem(item)"></Icon>
                </div>
              </div>
            </div>
          </FormItem>
          <FormItem :label="fileReq.name" :prop="`attachments[${getAttachmentIndex(idx)}].url`"
            v-for="(fileReq,idx) in fileRequirements"
            :key="idx"
            :rules="fileReq.isRequired?[{required:true,message:'必填',trigger:'blur'}]:null">
            <Upload
              :data="OSSParam"
              :before-upload="handleBeforeUpload"
              :multiple="false"
              :on-success="handleUploadSuccess"
              :format="fileReq.formats!=='*'?fileReq.formats.split(','):[]"
              :on-format-error="handleFormatError"
              :show-upload-list="false"
              :action="uploadParams.host">
              <Poptip trigger="hover" placement="right">
                <Button @click="getOSSParams(idx+1, fileReq.name, 3)"><Icon type="ios-cloud-upload-outline"></Icon>上传附件</Button>
                <div slot="content">
                  <p>{{fileReq.description}}</p>
                  <p>格式限制：{{fileReq.formats}}</p>
                  <p>大小限制：{{fileReq.maxLength}}kb</p>
                </div>
              </Poptip>
            </Upload>
            <div class="contract" v-if="guaModel.attachments&&guaModel.attachments instanceof Array&&guaModel.attachments.length">
              <template v-if="currentFileRequirement(idx)&&currentFileRequirement(idx).urls&&(currentFileRequirement(idx).urls instanceof Array)&&currentFileRequirement(idx).urls.length">
                <div class="contract-thumb" v-for="(item,upIdx) in currentFileRequirement(idx).urls" :key="upIdx">
                  <img :src="item.url" v-if="item&&item.url&&item.type==='image'">
                  <span style="font-weight:bold;color:#999" v-if="item&&item.url&&item.type==='file'">{{item.surfix.toUpperCase()}}</span>
                  <div class="contract-thumb-cover">
                    <Icon type="ios-eye-outline" v-if="item&&item.url&&item.type==='image'" @click="handleImgPreview(currentFileRequirement(idx).urls, upIdx)"></Icon>
                    <Icon type="ios-eye-outline" v-if="item&&item.url&&item.type==='file'" @click="previewImgUrl=item;showPreview=true"></Icon>
                    <Icon type="ios-trash-outline" @click="removeAttachmentItem(item,idx)"></Icon>
                  </div>
                </div>
              </template>
            </div>
          </FormItem>
          <div class="padding-top-20"></div>
          <Row :gutter="16">
            <Col span="4"><Button type="warning" size="large" style="display:inline" @click="backward">上一步</Button></Col>
            <Col span="16"><Button type="primary" size="large" style="display:inline" long @click="submit">下一步</Button></Col>
            <Col span="4"><Button type="info" size="large" style="display:inline" long @click="draft">存草稿</Button></Col>
          </Row>
        </Form>
      </i-col>
    </Row>
    <Modal v-model="showPreview" title="查看图片" @on-cancel="showPreview=false;previewImgUrl=null" width="1200">
      <img :src="previewImgUrl" v-if="showPreview&&typeof(previewImgUrl)==='string'" style="width: 100%">
      <img :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='image'" style="width: 100%">
      <iframe :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'&&previewImgUrl.surfix==='pdf'" width="100%" height="800"></iframe>
      <a :href="previewImgUrl.url" target="_blank" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'&&previewImgUrl.surfix!='pdf'">查看</a>
    </Modal>
    <image-preview
      :minScale="1"
      :image-urls="imageUrls"
      :visible.sync="visiblePreviewer"
      :start-position="startPosition"></image-preview>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
import configs from './../../../configs'
export default {
  name: 'guarantee-new',
  props: {
    data: Object
  },
  data () {
    const asyncAllowanceValidator = (rule, value, callback) => {
      this.$Api.Guarantee.checkAllowance(value * 100, this.$store.getters.guarantorInfo.id, this.data.cityId, this.data.industryId)
      .then((res) => {
        if (res) {
          callback()
        } else {
          callback(new Error('超出限额'))
        }
      }).catch(err => {
        callback(err)
      })
    }
    const asyncMinRateValidator = (rule, value, callback) => {
      this.$Api.Guarantee.checkMinRate(value * 1000000, this.$store.getters.guarantorInfo.id, this.data.cityId, this.data.industryId)
      .then((res) => {
        if (res) {
          callback()
        } else {
          callback(new Error('超出限额'))
        }
      }).catch(err => {
        callback(err)
      })
    }
    return {
      loading: false,
      guaModel: {
        beneficiary: null,
        beneficiaryBusinessLicense: null,
        beneficiaryAddress: null,
        guaranteed: null,
        guaranteedBusinessLicense: null,
        guaranteedAddress: null,
        amount: 0,
        fee: null,
        amountCostRatio: 0,
        variety: 0,
        counterRatio: 0,
        counterCash: 0,
        counter3rdparty: 0,
        counterMortgage: 0,
        counterOther: 0,
        counterTotal: 0,
        gMethod: 0,
        gStartDate: null,
        gEndDate: null,
        gFeeRate: 0,
        opName: null,
        opContactTel: null,
        jointGuarantors: [],
        contractOssKeys: [],
        attachments: []
      },
      modelValidate: {
        beneficiary: [
          { required: true, message: '请填写受益人', trigger: 'blur' }
        ],
        beneficiaryBusinessLicense: [
          { required: true, message: '请填写受益人社会信用代码', trigger: 'blur' }
        ],
        guaranteed: [
          { required: true, message: '请填写被保证人', trigger: 'blur' }
        ],
        guaranteedBusinessLicense: [
          { required: true, message: '请填写被保证人社会信用代码', trigger: 'blur' }
        ],
        fee: [
          { required: true, type: 'number', message: '请填写担保费总额', trigger: 'blur' }
        ],
        amount: [
          { required: true, type: 'number', message: '请填写担保金额', trigger: 'blur' },
          { validator: asyncAllowanceValidator, trigger: 'change' }
        ],
        amountCostRatio: [
          { required: true, type: 'number', message: '请填写保额造价比', trigger: 'blur' }
        ],
        variety: [
          { required: true, type: 'number', message: '请选择担保种类', trigger: 'blur' }
        ],
        counterRatio: [
          { required: true, type: 'number', message: '请填写反担保比例', trigger: 'blur' }
        ],
        counterCash: [
          { required: true, type: 'number', message: '请填写现金反担保', trigger: 'blur' }
        ],
        counter3rdparty: [
          { required: true, type: 'number', message: '请填写第三方反担保', trigger: 'blur' }
        ],
        counterMortgage: [
          { required: true, type: 'number', message: '请填写抵押质押反担保', trigger: 'blur' }
        ],
        counterOther: [
          { required: true, type: 'number', message: '请填写其他反担保', trigger: 'blur' }
        ],
        gMethod: [
          { required: true, type: 'number', message: '请选择保证方式', trigger: 'blur' }
        ],
        gStartDate: [
          { required: true, message: '请填写起始日期', trigger: 'blur' }
        ],
        gEndDate: [
          { required: true, message: '请填写截止日期', trigger: 'blur' }
        ],
        gFeeRate: [
          { required: true, type: 'number', message: '请填写费率', trigger: 'blur' },
          { validator: asyncMinRateValidator, trigger: 'change' }
        ],
        opName: [
          { required: true, message: '请填写上报人', trigger: 'blur' }
        ],
        opContactTel: [
          { required: true, message: '请填写联系方式', trigger: 'blur' }
        ]
      },
      guaTypes: [],
      avaliableGuarantors: [],
      jointGuarantor: {
        guarantorId: null,
        amount: 0
      },
      uploadParams: {
        accessid: '',
        host: '',
        policy: '',
        signature: '',
        callbackbody: '',
        key: '',
        expire: 0
      },
      curOSSParamIndex: null,
      OSSParams: [],
      OSSParam: {
        name: '',
        key: '',
        policy: '',
        OSSAccessKeyId: '',
        success_action_status: '200',   // 让服务端返回200,不然，默认会返回204
        signature: '',
        fileIndex: 0
      },
      uploadList: [],
      uploadedContractArray: [],
      previewImgUrl: null,
      showPreview: false,
      fileRequirements: [],
      fileRequirementsUploaded: [],
      visiblePreviewer: false,
      imageUrls: [],
      startPosition: 0
    }
  },
  watch: {
    'guaModel.gMethod': function (newVal, oldVal) {
      console.log(newVal, oldVal)
      this.listAvaliableJointGuarantors()
      if (newVal === 2 && (oldVal !== null && oldVal !== undefined) && (this.data.jointGuarantors && this.data.jointGuarantors instanceof Array && !this.data.jointGuarantors.length)) {
        this.guaModel.jointGuarantors = [{
          guarantorId: null,
          amount: null
        }]
      } else if (this.data.jointGuarantors && this.data.jointGuarantors instanceof Array && this.data.jointGuarantors.length) {
        // do nothing
        if (oldVal === 2) {
          this.guaModel.jointGuarantors = [{
            guarantorId: null,
            amount: null
          }]
        }
      } else {
        this.guaModel.jointGuarantors = null
      }
      this.reCalcRatios()
    },
    'guaModel.counterCash': function (newVal) {
      try {
        this.guaModel.counterTotal = newVal
          + this.guaModel.counter3rdparty
          + this.guaModel.counterMortgage
          + this.guaModel.counterOther
        this.guaModel.counterRatio = Math.round(this.guaModel.counterTotal / this.guaModel.amount * 10000) / 10000
        this.reCalcRatios()
      } catch (e) {
        this.guaModel.counterTotal = 0
        this.guaModel.counterRatio = 0
        this.reCalcRatios()
      }
    },
    'guaModel.counter3rdparty': function (newVal) {
      try {
        this.guaModel.counterTotal = newVal
          + this.guaModel.counterCash
          + this.guaModel.counterMortgage
          + this.guaModel.counterOther
        this.guaModel.counterRatio = Math.round(this.guaModel.counterTotal / this.guaModel.amount * 10000) / 10000
        this.reCalcRatios()
      } catch (e) {
        this.guaModel.counterTotal = 0
        this.guaModel.counterRatio = 0
        this.reCalcRatios()
      }
    },
    'guaModel.counterMortgage': function (newVal) {
      try {
        this.guaModel.counterTotal = newVal
          + this.guaModel.counter3rdparty
          + this.guaModel.counterCash
          + this.guaModel.counterOther
        this.guaModel.counterRatio = Math.round(this.guaModel.counterTotal / this.guaModel.amount * 10000) / 10000
        this.reCalcRatios()
      } catch (e) {
        this.guaModel.counterTotal = 0
        this.guaModel.counterRatio = 0
        this.reCalcRatios()
      }
    },
    'guaModel.counterOther': function (newVal) {
      try {
        this.guaModel.counterTotal = newVal
          + this.guaModel.counter3rdparty
          + this.guaModel.counterMortgage
          + this.guaModel.counterCash
        this.guaModel.counterRatio = Math.round(this.guaModel.counterTotal / this.guaModel.amount * 10000) / 10000
        this.reCalcRatios()
      } catch (e) {
        this.guaModel.counterTotal = 0
        this.guaModel.counterRatio = 0
        this.reCalcRatios()
      }
    },
    'guaModel.amount': function (newVal) {
      try {
        this.guaModel.counterTotal = this.guaModel.counter3rdparty
          + this.guaModel.counterCash
          + this.guaModel.counterMortgage
          + this.guaModel.counterOther
        this.guaModel.counterRatio = Math.round(this.guaModel.counterTotal / this.guaModel.amount * 10000) / 10000
        this.guaModel.amountCostRatio = Math.round(newVal / this.data.project.cost * 10000) / 10000
        this.reCalcRatios()
      } catch (e) {
        this.guaModel.amountCostRatio = 0
        this.guaModel.counterRatio = 0
        this.reCalcRatios()
      }
    }
  },
  mounted () {
    this.initGuaTypes()
    if (!this.data.cityId) {
      this.$router.push({path: '/guarantees/new/step1'})
    } else {
      if (this.data.project) {
        Object.assign(this.guaModel, this.data)
        this.guaModel.jointGuarantors = this.data.jointGuarantors
        // if (this.guaModel.jointGuarantors && this.guaModel.jointGuarantors instanceof Array) {
        //   this.guaModel.jointGuarantors.forEach((g) => {
        //     g.amount /= 100
        //   })
        // }
      }
    }
    if (this.data.contractOssKeys && this.data.contractOssKeys instanceof Array && this.data.contractOssKeys.length) {
      this.procOssKeys(this.data.contractOssKeys)
    }
    this.listFileRequirements()
    this.uploadList = this.$refs.contractUploader.fileList
    if (!this.guaModel.opName) {
      this.guaModel.opName = this.$store.getters.userInfo.displayName
    }
    if (!this.guaModel.opContactTel) {
      this.guaModel.opContactTel = this.$store.getters.userInfo.mobile
    }
    if (this.guaModel.gStartDate) {
      this.guaModel.gStartDate = require('moment')(this.guaModel.gStartDate).format('YYYY-MM-DD')
    }
    if (this.guaModel.gEndDate) {
      this.guaModel.gEndDate = require('moment')(this.guaModel.gEndDate).format('YYYY-MM-DD')
    }
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getAttachmentIndex (fileReqIdx) {
      let fileReq = this.fileRequirements[fileReqIdx]
      return this.guaModel.attachments.findIndex(o => o.name === fileReq.name)
    },
    getSysConfig (key) {
      return configs(key)
    },
    backward () {
      this.$emit('go-backward')
    },
    changeStartDate (date) {
      this.guaModel.gStartDate = date
    },
    changeEndDate (date) {
      this.guaModel.gEndDate = date
    },
    arrayValidator (rule, value, callback) {
      if (!value || !(value instanceof Array) || !value.length) {
        callback(new Error('没有元素'))
      } else {
        callback()
      }
    },
    async initGuaTypes () {
      return new Promise((resolve, reject) => {
        this.$Spin.show()
        this.$Api.Guarantee.getGuaranteeVarieties().then(res => {
          this.guaTypes = res
          this.$Spin.hide()
          resolve(res)
        }).catch(err => {
          this.$Message.error(err.message)
          this.$Spin.hide()
          reject(err)
        })
      })
    },
    async listAvaliableJointGuarantors () {
      return new Promise((resolve, reject) => {
        this.$Spin.show()
        this.$Api.Guarantor.listJointGuarantors(this.data.cityId, this.data.industryId).then(res => {
          this.avaliableGuarantors = res
          this.$Spin.hide()
          resolve(res)
        }).catch(err => {
          this.$Message.error(err.message)
          this.$Spin.hide()
          reject(err)
        })
      })
    },
    getAvaliableGuarantors (idx) {
      let selectedGuarantors = this.guaModel.jointGuarantors.map((j, index) => {
        if (index !== idx) {
          return j.guarantorId
        }
      })
      return this.avaliableGuarantors.filter((g) => {
        return selectedGuarantors.indexOf(g.guarantorId) < 0
      })
    },
    asyncJointGuarantorAllowanceValidator (rule, value, callback) {
      let opt = rule.options
      let guarantorId = opt.model.guarantorId
      this.$Api.Guarantee.checkAllowance(value * 100, guarantorId, this.data.cityId, this.data.industryId)
      .then((res) => {
        if (res) {
          callback()
        } else {
          callback(new Error('超出限额'))
        }
      }).catch(err => {
        callback(err)
      })
    },
    changeJointAmount () {
      this.reCalcRatios()
    },
    reCalcRatios () {
      console.log('recalculate ratios')
      let totalAmount = this.guaModel.amount
      if (this.guaModel.jointGuarantors && this.guaModel.jointGuarantors instanceof Array) {
        this.guaModel.jointGuarantors.forEach((j) => {
          totalAmount += j.amount
        })
      }
      this.guaModel.counterTotal = this.guaModel.counter3rdparty
          + this.guaModel.counterCash
          + this.guaModel.counterMortgage
          + this.guaModel.counterOther
      console.log(totalAmount)
      this.guaModel.counterRatio = Math.round(this.guaModel.counterTotal / totalAmount * 10000) / 10000
      this.guaModel.amountCostRatio = Math.round(totalAmount / this.data.project.cost * 10000) / 10000
    },
    addJointGuarantor () {
      if (!this.guaModel.jointGuarantors || !(this.guaModel.jointGuarantors instanceof Array)) {
        this.guaModel.jointGuarantors = []
      }
      this.guaModel.jointGuarantors.push({
        guarantorId: null,
        amount: null
      })
      this.reCalcRatios()
    },
    removeJointGuarantor (g) {
      this.guaModel.jointGuarantors.splice(this.guaModel.jointGuarantors.indexOf(g), 1)
      this.reCalcRatios()
    },
    async draft () {
      this.$Spin.show()
      let draft = {}
      if (!this.data.guarantorId) {
        this.data.guarantorId = this.$store.getters.guarantorInfo.id
      }
      if (this.guaModel.jointGuarantors && this.guaModel.jointGuarantors instanceof Array) {
        this.guaModel.jointGuarantors.forEach((j) => {
          j.amount *= 100
        })
      }
      Object.assign(draft, this.guaModel)
      draft.guarantorId = this.data.guarantorId
      draft.amount = this.guaModel.amount * 100
      draft.fee = this.guaModel.fee * 100
      draft.counterTotal = this.guaModel.counterTotal * 100
      draft.counterCash = this.guaModel.counterCash * 100
      draft.counter3rdparty = this.guaModel.counter3rdparty * 100
      draft.counterMortgage = this.guaModel.counterMortgage * 100
      draft.counterOther = this.guaModel.counterOther * 100
      draft.contractOssKeys = this.uploadedContractArray.map((u) => {
        return u.name
      })
      draft.gStartDate = require('moment')(this.guaModel.gStartDate).format('YYYY-MM-DD HH:mm:ss')
      draft.gEndDate = require('moment')(this.guaModel.gEndDate).format('YYYY-MM-DD HH:mm:ss')
      this.$Api.Guarantee.draftGuarantee(draft).then(() => {
        this.$Message.success('操作成功')
        this.$Spin.hide()
        this.$router.push('/guarantees/list')
      }).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
    },
    currentFileRequirement (idx) {
      let req = this.fileRequirements[idx]
      let att = this.guaModel.attachments.find(o => o.name === req.name)
      return att
    },
    async listFileRequirements () {
      return new Promise((resolve, reject) => {
        this.$Spin.show()
        this.$Api.Guarantee.listFileRequirements({
          guarantorId: this.data.guarantorId
        }, 1, -1).then(res => {
          console.log(res)
          this.fileRequirementsUploaded = []
          let list = []
          if (res.data.length > 0) {
            list = res.data.sort((a, b) => {
              return a.tid - b.tid
            })
          }
          list.forEach((f) => {
            this.$nextTick(() => {
              let att = this.guaModel.attachments.find(o => o.name === f.name)
              if (!att) {
                console.log('null')
                this.guaModel.attachments.push({
                  id: f.tid,
                  ossKeys: [],
                  fileUrls: [],
                  name: f.name,
                  url: null,
                  urls: []
                })
              }
              this.fileRequirementsUploaded.push({
                id: f.tid,
                ossKeys: [],
                fileUrls: []
              })
            })
          })
          if (this.guaModel.attachments && this.guaModel.attachments.length) {
            this.$nextTick(() => {
              this.guaModel.attachments.forEach((att) => {
                att.urls = []
                let urls = att.url ? att.url.split(',') : []
                this.$nextTick(() => {
                  urls.forEach(async (u) => {
                    let itemUrl = u
                    if (u.indexOf('oss:') === 0) {
                      itemUrl = await this.procOssKey(u)
                      this.$nextTick(() => {
                        att.urls.push(itemUrl)
                        this.$nextTick(() => {})
                      })
                    }
                    // this.$nextTick(() => {
                    //   att.urls.push({
                    //     name: u,
                    //     status: 'finished',
                    //     url: itemUrl
                    //   })
                    //   this.$nextTick(() => {})
                    // })
                  })
                })
              })
            })
          }
          this.fileRequirements = res.data
          // setTimeout(() => {
          //   this.fileRequirements = res.data
          // }, 1000)
          this.$Spin.hide()
          resolve(res)
        }).catch(err => {
          this.$Message.error(err.message)
          this.$Spin.hide()
          reject(err)
        })
      })
    },
    getOSSParams (index, name, type = 1) {
      // type: 1-合同|2-竣工|3-其他
      this.$Api.Guarantee.getUploadParams(type).then((res) => {
        console.log(res)
        this.uploadParams = {
          name: name,
          accessid: res.accessid,
          host: res.host,
          policy: res.policy,
          signature: res.signature,
          callbackbody: res.callbackbody,
          key: res.dir,
          expire: res.expire
        }
        this.uploadParams.host = this.uploadParams.host.replace('-internal', '')
        this.curOSSParamIndex = index    // 上传控件序号
      }).catch(err => {
        this.$Message.error(err.message)
      })
    },
    async procOssKey (k) {
      let url = await this.procOSSUrl(k)
      return new Promise((resolve, reject) => {
        try {
          let surfix = url.substr(url.lastIndexOf('.') + 1).toLowerCase()
          if (surfix.indexOf('?')) {
            surfix = surfix.substring(0, surfix.indexOf('?'))
          }
          let type = 'image'
          switch (surfix) {
            case 'jpg':
              type = 'image'
              break
            case 'jpeg':
              type = 'image'
              break
            case 'png':
              type = 'image'
              break
            case 'gif':
              type = 'image'
              break
            case 'pdf':
              type = 'file'
              break
            case 'doc':
              type = 'file'
              break
            case 'docx':
              type = 'file'
              break
            case 'xls':
              type = 'file'
              break
            case 'xlsx':
              type = 'file'
              break
            case 'ppt':
              type = 'file'
              break
            case 'pptx':
              type = 'file'
              break
            default:
              type = 'file'
              break
          }
          let obj = {
            name: k,
            url,
            type,
            surfix
          }
          resolve(obj)
          return obj
        } catch (er) {
          reject(er)
        }
      })
    },
    procOssKeys (keys) {
      keys.forEach(async (k) => {
        try {
          if (typeof(k) === 'string') {
            let keyObj = await this.procOssKey(k)
            this.uploadedContractArray.push(keyObj)
          } else if (typeof(k) === 'object' && k.url) {
            this.uploadedContractArray.push({
              name: k.name,
              url: k.url,
              type: k.type,
              surfix: k.prefix
            })
          }
        } catch (e) {
          console.log(e)
        }
      })
      this.$nextTick(() => {
        this.uploadList = this.$refs.contractUploader.fileList
      })
    },
    procOSSUrl (_key) {
      return new Promise((resolve, reject) => {
        let url = ''
        let ossKey = window.encodeURIComponent(window.btoa(_key))
        Api.Guarantee.getOssUrl(ossKey).then((res) => {
          // console.log(typeof(res), res)
          url = res
          resolve(url)
        }).catch(err => {
          this.$Message.error('获取文件地址失败!' + err.message)
          reject(err)
        })
      })
    },
    removeItem (item) {
      let idx = this.uploadedContractArray.findIndex(o => o.name === item.name)
      this.uploadedContractArray.splice(idx, 1)
      let modelIdx = this.guaModel.contractOssKeys.findIndex(o => o === item.name)
      this.guaModel.contractOssKeys.splice(modelIdx, 1)
    },
    removeAttachmentItem (item, attachIdx) {
      let attach = this.currentFileRequirement(attachIdx)
      let idx = attach.urls.findIndex(o => o.name === item.name)
      attach.urls.splice(idx, 1)
      let keys = attach.url.split(',')
      keys.splice(idx, 1)
      keys = keys.join(',')
      console.log(keys)
      attach.url = keys
    },
    handleBeforeUpload (file) {
      let filename = this.uploadParams.key + this.randomString(10) + this.getSuffix(file.name)
      this.OSSParams[this.curOSSParamIndex] = {
        name: this.uploadParams.name,
        filename: file.name,
        key: filename,
        policy: this.uploadParams.policy,
        OSSAccessKeyId: this.uploadParams.accessid,
        success_action_status: '200',   // 让服务端返回200,不然，默认会返回204
        signature: this.uploadParams.signature,
        fileIndex: this.curOSSParamIndex
      }
      this.OSSParam.name = this.uploadParams.name
      this.OSSParam.filename = file.name
      this.OSSParam.key = filename
      this.OSSParam.policy = this.uploadParams.policy
      this.OSSParam.OSSAccessKeyId = this.uploadParams.accessid
      this.OSSParam.success_action_status = '200'   // 让服务端返回200,不然，默认会返回204
      this.OSSParam.signature = this.uploadParams.signature
      this.OSSParam.fileIndex = this.curOSSParamIndex
    },
    async handleUploadSuccess (response, file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      let ossParam = this.OSSParams.filter((item) => {
        return item.filename === file.name
      })[0]
      console.log(ossParam)
      let filename = 'oss:' + ossParam.key
      file.name = filename
      this.$nextTick(async () => {
        await this.procOssKey(filename).then(async (keyObj) => {
          console.log(keyObj.url)
          file.url = keyObj.url
          if (ossParam.fileIndex > 0) {
            this.fileRequirementsUploaded[ossParam.fileIndex - 1].ossKeys.push(filename)
            this.fileRequirementsUploaded[ossParam.fileIndex - 1].fileUrls.push(keyObj.url)
            let attachExist = this.guaModel.attachments.filter((a) => {
              return a.name === ossParam.name
            })
            if (attachExist && attachExist.length) {
              if (typeof(attachExist[0].url) === 'string') {
                let urls = attachExist[0].url.split(',')
                if (urls.length) {
                  urls.push(filename)
                } else {
                  urls = [filename]
                }
                attachExist[0].url = urls.join(',')
              } else if (attachExist[0].url instanceof Array) {
                attachExist[0].url = attachExist[0].url.push(filename).join(',')
              } else {
                attachExist[0].url = filename
              }
              if (attachExist[0].urls) {
                attachExist[0].urls.push(keyObj)
              } else {
                console.log(222)
                attachExist[0].urls = []
                this.$nextTick(() => {
                  attachExist[0].urls.push(keyObj)
                  console.log(attachExist[0].urls)
                })
              }
            } else {
              console.log(111)
              this.guaModel.attachments.push({
                name: ossParam.name,
                type: 3,
                url: filename,
                urls: [keyObj]
              })
            }
          } else {
            // 担保合同
            if (this.guaModel.contractOssKeys === null) {
              this.guaModel.contractOssKeys = []
            }
            this.guaModel.contractOssKeys.push(filename)
            this.uploadedContractArray.push(keyObj)
          }
        })
        this.$nextTick(async () => {
          
        })
      })
    },
    handleFormatError () {
      this.$Notice.warning({
        title: '文件格式不正确',
        desc: '上传文件格式不正确。'
      })
    },
    onValidate (prop, status, error) {
      console.log(prop, status, error)
    },
    async submit () {
      try {
        console.log('submit step4')
        this.$refs.newForm.validate((valid) => {
          console.log(valid)
          if (valid) {
            let keys = []
            this.uploadedContractArray.forEach((u) => {
              keys.push(u.name)
            })
            this.guaModel.attachments.forEach((a, idx) => {
              if (!a.url) {
                this.guaModel.attachments.splice(idx, 1)
              }
            })
            console.log(keys)
            let model = {}
            Object.assign(model, this.guaModel)
            model.amount *= 100
            model.fee *= 100
            if (model.jointGuarantors && model.jointGuarantors instanceof Array) {
              model.jointGuarantors = model.jointGuarantors.map((j) => {
                if (j.amount) {
                  j.amount *= 100
                }
                j.guarantorName = this.avaliableGuarantors.find(o => o.guarantorId === j.guarantorId).guarantorName
                return {
                  amount: j.amount,
                  guarantorId: j.guarantorId,
                  guarantorName: j.guarantorName
                }
              })
            }
            model.contractOssKeys = []
            model.contractOssKeys = keys
            model.gStartDate = require('moment')(this.guaModel.gStartDate).format('YYYY-MM-DD HH:mm:ss')
            model.gEndDate = require('moment')(this.guaModel.gEndDate).format('YYYY-MM-DD HH:mm:ss')
            console.log(keys, model.contractOssKeys, model)
            this.$emit('finish-step4', model)
          }
        }).catch((errors, fields) => {
          console.log(errors, fields)
        })
      } catch (err) {
        console.log(err)
      }
    },
    randomString (len) {
      len = len || 32
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      var maxPos = chars.length
      var pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    getSuffix (filename) {
      let pos = filename.lastIndexOf('.')
      let suffix = ''
      if (pos !== -1) {
        suffix = filename.substring(pos)
      }
      return suffix
    },
    handleImgPreview (list, index) {
      this.imageUrls = list.map((l) => {return l.url})
      this.visiblePreviewer = true
      this.startPosition = index
    }
  }
}
</script>

<style lang="less" scoped>
.avatar-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  .student-avatar {
    width: 200px;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #efefef;
  }
}
.joint-guarantor {
  padding: 15px 15px 25px 15px;
  border: 1px solid #e2e2e2;
  background: #f8f8f8;
  margin-bottom: 10px;
  position: relative;
  .remove-jointguarantor {
    position: absolute;
    top: 5px;
    right: 5px;
  }
}
.contract {
  display: flex;
  flex-direction: row;
  margin: 10px 0;
}
.contract-thumb {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-color: #efefef;
  width: 100px;
  height: 100px;
  margin-right: 4px;
  transition: all .2s ease-in-out;
  padding: 3px;
  border: 1px solid #d2d2d2;
  position: relative;
  &:hover {
    border: 1px solid rgb(65,157,253);
    background-color: #fff;
  }
  overflow: hidden;
  img {
    width: 100%;
    cursor: pointer;
  }
  .contract-thumb-cover{
    opacity: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
    transition: all .3s linear;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  &:hover .contract-thumb-cover{
    opacity: 1;
  }
  .contract-thumb-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 5px;
  }
}
</style>
